import { BookPlus, Building, KeyRound, MessageCirclePlus, UserPlus, UserRoundPen } from "lucide-react";
import { may } from "@/abilities";
import { knowledgeBaseNewPath, settingsApiKeysPath, settingsPath, settingsProfilePath } from "@/routes";
import { chatbotsNewPath } from "@/routes/path_helpers/chatbots";
export const getCpSettingsPages = (session) => [
    {
        title: "Unternehmenseinstellungen",
        url: settingsPath(),
        icon: Building,
        may: may(session, "settings/company"),
    },
    {
        title: "Profileinstellungen",
        url: settingsProfilePath(),
        icon: UserRoundPen,
        may: may(session, "settings/profile"),
    },
    {
        title: "API-Key Einstellungen",
        url: settingsApiKeysPath(),
        icon: KeyRound,
        may: may(session, "settings/api-keys"),
    },
];
export const USER_STATUS_OPTIONS = [
    { value: "READY", icon: "🟢", label: "verfügbar" },
    { value: "AWAY", icon: "🔴", label: "nicht verfügbar" },
];
export const getCpActionCommands = (session, onCreateUser) => [
    {
        title: "Benutzer erstellen",
        key: "create-user",
        icon: UserPlus,
        may: may(session, "users", "new"),
        run: onCreateUser,
    },
    {
        title: "Chatbot erstellen",
        key: "create-chatbot",
        url: chatbotsNewPath(),
        icon: MessageCirclePlus,
        may: may(session, "chatbots", "new"),
    },
    {
        title: "Wissensdatenbank erstellen",
        key: "create-knowledgebase",
        url: knowledgeBaseNewPath(),
        icon: BookPlus,
        may: may(session, "knowledgebase", "new"),
    },
];
